import { createFileRoute, Outlet } from '@tanstack/react-router'
import { AppLayout } from '@/components/layout'
import { AuthGuard } from '@/components/auth'

export const Route = createFileRoute('/_app')({
  component: AppLayoutRoute,
})

function AppLayoutRoute() {
  return (
    <AuthGuard>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </AuthGuard>
  )
}
